import { InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { validDecimalAndLength } from '../../ModificationsUtils';

export const UtilityCharges = () => {
  const { control, getValues, setValue } = useFormContext();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const utilityCharge = 'utilityCharge';
  const utilityChargeW: number = useWatch({ name: utilityCharge });
  const isModEdit = useSelector(selectIsEditMod);
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name={utilityCharge}
      rules={{
        required: false,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={getValues(utilityCharge) ?? ''}
          onChange={e => {
            if (validDecimalAndLength(e.target.value, { numberLength: 6, decimalLength: 2 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              setValue(utilityCharge, validInput);
              onChange(validInput);
            }
          }}
          InputLabelProps={{
            shrink: utilityChargeW ? true : false,
          }}
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: <>{value && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>,
          }}
          variant="filled"
          fullWidth
          id="utilityCharge"
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.utilityCharge')}
          disabled={isSaveModApiCalling}
          {...rest}
        />
      )}
    />
  );
};
